import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { getGraphQLStyleErrorMessage } from '@jepto/shared/utils/graphql-style-error-message.util';

@Injectable()
export class AnalyticsSentryErrorHandler implements ErrorHandler {
	handleError(error: unknown): void {
		try {
			const toCapture = this.normalizeForSentry(
				(error as { originalError?: unknown })?.originalError ?? error
			);
			if (toCapture) {
				const hasClient =
					typeof Sentry.getClient === 'function' &&
					!!Sentry.getClient();
				if (!hasClient) {
					return;
				}
				Sentry.captureException(toCapture);
			}
		} catch (sentryError) {
			console.warn(
				'[Analytics][Sentry] captureException failed:',
				sentryError
			);
		}
		console.error(error);
	}

	private normalizeForSentry(err: unknown): Error | null {
		if (!err) return null;
		if (err instanceof Error) return err;
		const gqlMessage = getGraphQLStyleErrorMessage(err);
		if (gqlMessage !== null) return new Error(gqlMessage);
		if (typeof err === 'object') {
			return new Error(
				(err as { message?: string }).message ?? JSON.stringify(err)
			);
		}
		return new Error(String(err));
	}
}
